import { Component, ErrorInfo, ReactNode } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary a capturé :', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/Home';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center', color: '#fff',
          background: '#111', padding: '2rem', textAlign: 'center',
        }}>
          <h1 style={{ color: '#DABB27' }}>Oups, une erreur est survenue</h1>
          <p>Notre équipe a été notifiée. Vous pouvez retourner à l'accueil.</p>
          <button
            onClick={this.handleReset}
            style={{
              background: '#DABB27', color: '#000', border: 'none',
              padding: '0.75rem 2rem', borderRadius: '2rem',
              cursor: 'pointer', fontWeight: 700, marginTop: '1rem',
            }}
          >
            Retour à l'accueil
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;